const SDK_SRC = 'https://sdk.mercadopago.com/js/v2'
let sdkPromise

export function loadMercadoPago(publicKey) {
  if (!sdkPromise) {
    sdkPromise = window.MercadoPago
      ? Promise.resolve()
      : new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.src = SDK_SRC
          script.async = true
          script.onload = () => resolve()
          script.onerror = () => reject(new Error('Não foi possível carregar o Mercado Pago.'))
          document.head.appendChild(script)
        })
  }
  return sdkPromise.then(() => new window.MercadoPago(publicKey, { locale: 'pt-BR' }))
}
